import React from 'react';
import { Routes, Route } from 'react-router-dom';
import * as routes from 'constants/routeNames';
import PageNotFound from 'containers/PageNotFound/PageNotFound';
import { Home } from 'containers/Home/Home';
import { Error } from 'containers/Error/error';
import UserAccount from 'containers/CuentasUsuarios/CuentasUsuarios/UserAccount';
import { UsuariosContextProvider } from 'contexts/UsuariosContext';
import { DispositivosContextProvider } from 'contexts/DispositivosContext';
import { IdentificacionSO } from 'containers/CuentasUsuarios/IdentificacionSO/IdentificacionSO';
import { MediosImpContextProvider } from 'contexts/MediosImpContext';
import { VisitasEventosContextProvider } from 'contexts/VisitasEventosContext';
import { Monitoreo } from 'containers/Monitoreos/Monitoreos';
import { ActaInicio } from 'containers/MonitoreoActaInicio/Pages/ActaInicio/ActaInicio';
import { ActaCierre } from 'containers/MonitoreoActaCierre/Pages/ActaCierre/ActaCierre';
import NuevoDispositivo from 'containers/Dispositivos/Nuevo/NuevoDispositivo';
import AsignarDispositivo from 'containers/Dispositivos/Asignar/AsignarDispositivo';
import PropagandaViaPublica from 'containers/MonitoreosEspectaculares/PropagandaViaPublica/Pages/PropagandaViaPublica/PropagandaViaPublica';
import MediosImpresos from 'containers/Monitoreos/MediosImpresos/MediosImpresos';
import MonitoreosInternet from 'containers/MonitoreosInternet/MonitoreosInternet';
import MonitoreosEventos from 'containers/Monitoreos/VisitasEventos/MonitoreosEventos';
import MonitoreosCasas from 'containers/Monitoreos/VisitasCasas/MonitoreosCasas';
import { Geocercas } from 'containers/Geocercas/Geocercas';
import { Descargas } from 'containers/Descargas/Descargas/Descargas';
import { GeneracionEnlaces } from 'containers/Descargas/GeneracionEnlaces/GeneracionEnlaces';
import CatalogoMediosImpresos from 'containers/GestionContenido/CatalogoMediosImpresos/CatalogoMediosImpresos';
import { CatalogoFechas } from 'containers/GestionContenido/CatalogoFechas/Pages/CatalogoFechas/CatalogoFechas';
import { DescargasPublicas } from 'containers/PortalPublico/Descargas/Pages/DescargasPublicas';
import EdicionPlantillas from 'containers/GestionContenido/EdicionPlantillas/EdicionPlantillas';
import EditSelectedTemplate from 'containers/GestionContenido/EdicionPlantillas/components/EditTemplate/EditSelectedTemplate';
import { CentroAyuda } from 'containers/CentroAyuda/CentroAyuda';
import { BitacoraSincronizacion } from 'containers/Reportes/BitacoraSincronizacion/BitacoraSincronizacion';
import { BitacoraNotificacion } from 'containers/Reportes/BitacoraNotificacion/BitacoraNotificacion';
import { ReporteUsuarios } from 'containers/Reportes/ReporteUsuarios/page/ReporteUsuarios';
import { Gluster } from 'containers/Gluster/Gluster';
import Layout from 'Layouts/Layout';
import Login from 'containers/Login/Login';
import ConfiguracionCatalogos from 'containers/ConfiguracionCatalogos/ConfiguracionCatalogos';
import CatalogoTipoMediosImpresos from 'containers/GestionContenido/CatalogoTipoMediosImpresos/CatalogoTipoMediosImpresos';
import CatalogoTipoHallazgos from 'containers/GestionContenido/CatalogoTipoHallazgos/CatalogoTipoHallazgos';
import Sistemas from 'containers/Sistemas/Sistemas';
import AuthRequired from 'components/AuthRequired/AuthRequired';

const RouterContent = () => {
  return (
    <Routes>
      <Route path={routes.LOGIN_AUTH} element={<Login />} />
      <Route path={routes.SYSTEMS_ROUTE} element={<Sistemas />} />
      <Route path={routes.DESCARGAS_PORTAL_ROUTE} element={<DescargasPublicas />} />
      <Route path={routes.BASE_ROUTE} element={<AuthRequired />}>
        <Route path={routes.PAGE_NOT_FOUND_ROUTE} element={<PageNotFound />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
      <Route path={routes.BASE_ROUTE} element={<Layout />}>
        <Route
          path={routes.USER_ACCOUNT}
          element={
            <UsuariosContextProvider>
              <UserAccount />
            </UsuariosContextProvider>
          }
        />
        <Route path={routes.IDENTIFICACIONSO} element={<IdentificacionSO />} />
        <Route path={routes.NEW_DEVICE} element={<NuevoDispositivo />} />
        <Route
          path={routes.ASSIGN_DEVICE}
          element={
            <DispositivosContextProvider>
              <AsignarDispositivo />
            </DispositivosContextProvider>
          }
        />
        <Route path={routes.MONITOREOS_ROUTE} element={<Monitoreo />} />
        <Route path={routes.DESCARGAS} element={<Descargas />} />
        <Route path={routes.GENERACION_ENLACES} element={<GeneracionEnlaces />} />
        <Route path={routes.CENTRO_AYUDA} element={<CentroAyuda />} />
        <Route path={routes.ERROR_ROUTE} element={<Error />} />
        <Route path={routes.MONITOREOS_ACTA_INICIO_ROUTE} element={<ActaInicio />} />
        <Route path={routes.MONITOREOS_ACTA_CIERRE_ROUTE} element={<ActaCierre />} />
        <Route path={routes.MONITOREOS_INTERNET} element={<MonitoreosInternet />} />
        <Route path={routes.PROPAGANDA_PUBLICA} element={<PropagandaViaPublica />} />
        <Route path={routes.MON_VISITAS_CASAS} element={<MonitoreosCasas />} />
        <Route
          path={routes.MON_MEDIOS_IMPRESOS}
          element={
            <MediosImpContextProvider>
              <MediosImpresos />
            </MediosImpContextProvider>
          }
        />
        <Route
          path={routes.MON_VISITAS_EVENTOS}
          element={
            <VisitasEventosContextProvider>
              <MonitoreosEventos />
            </VisitasEventosContextProvider>
          }
        />
        <Route path={routes.HOME_ROUTE} element={<Home />} />
        <Route path={routes.GEOCERCAS} element={<Geocercas />} />
        <Route path={routes.EDICION_PLANTILLAS_ROUTE} element={<EdicionPlantillas />} />
        <Route path={routes.BITACORA_SINCRONIZACION_ROUTE} element={<BitacoraSincronizacion />} />
        <Route path={routes.BITACORA_NOTIFICACION_ROUTE} element={<BitacoraNotificacion />} />
        <Route path={routes.REPORTE_USUARIOS_ROUTE} element={<ReporteUsuarios />} />
        <Route path={routes.CONFIGURACION_CATALOGOS} element={<ConfiguracionCatalogos />} />
        <Route path={routes.CATALOGO_FECHAS_ROUTE} element={<CatalogoFechas />} />
        <Route path={routes.CATALOGO_MEDIOS_IMPRESOS_ROUTE} element={<CatalogoMediosImpresos />} />
        <Route path={routes.GLUSTER} element={<Gluster />} />
        <Route
          path={routes.CATALOGO_TIPO_MEDIOS_IMPRESOS_ROUTE}
          element={<CatalogoTipoMediosImpresos />}
        />
        <Route path={routes.CATALOGO_TIPO_HALLAZGOS_ROUTE} element={<CatalogoTipoHallazgos />} />
        <Route
          path={routes.EDICION_PLANTILLA_SELECCIONADA_ROUTE}
          element={<EditSelectedTemplate />}
        />
      </Route>
    </Routes>
  );
};

export default RouterContent;
